import $ from 'jquery';
import responsiveService from '../../Services/responsive';
import foldableWidget from '../../Widgets/ui/foldable';

const widgetList = [];

function initFoldable() {
  $('.js-foldable').each(function (n, foldableElement) {
    widgetList.push(foldableWidget.create(foldableElement));
  });

  responsiveService.registerOnChangeCallback(function (newSize) {
    widgetList.forEach(function (widget) {
      if (widget.options.mobileOnly) {
        widget.forceOpen(newSize !== 'small');
      }
    });
  });

  // handle auto open via url
  setTimeout(function () {
    var hash = window.location.hash,
      $elem;

    if (hash) {
      try {
        $elem = $(hash);
        if ($elem.length > 0 && $elem.data('OC-foldable')) {
          $elem.foldable('open');
        }
      } catch (e) {
        //
      }
    }
  }, 250);
}

export default {
  init: initFoldable,
};
